export default __webpack_public_path__ + "static/media/donacion_tratamiento.a0aed163.png";